import React from 'react'
import {Hero, Slider} from '../components'
import map1 from '../assets/images/morricana_map.webp'
import {sliderBosco, sliderPizzo} from '../utils/links'
import useTitle from '../custom/useTitle'
import useDescription from '../custom/useDescription'

function RoutesScreen() {
    useTitle("Percorsi");
    useDescription("Lista dei percorsi che puoi trovare a Ceppo!");
    return (
        <div>
            <Hero overlay>
                <hr/>
                    <div>
                        <h3>Itinerari di Ceppo</h3>
                    </div>
                <hr/>
            </Hero>
            <div className="section-text">
                <div className="section-image-container">
                    <div className="img-container">
                        <img src={map1} alt="mappa Morricana" className="section-image"/>
                    </div>
                    
                    <section className="section">
                        <h4 className="title">Ceppo - Cascata della Morricana</h4>
                        <hr/>
                        <div className="tag-section">
                            <span>Distanza: 7.23km</span>
                            <span>Dislivello: 468m</span>
                            <span>Tempo di Percorrenza: 3h</span>
                            <span className="hard">Impegnativo</span>
                        </div>
                        <p>Escursione nel cuore del <span style={{fontWeight:"bold"}}>Bosco della Martese</span>.<br/> Primi 5km pianeggianti, con una strada
                            in brecciolato circondata da faggi e qualche abete sporadico. Il bosco é cosí fitto 
                            da non lasciar passare nemmeno la luce del sole, un <span style={{fontWeight:"bold"}}>ambiente perfetto per godersi 
                            il fresco della montagna</span> nella calura estiva.<br/>
                            Gli ultimi 2 km invece cambiano completamente. Attraverso un sentiero stretto,
                            talvolta ripido ma perfettamente segnato e sicuro, si viaggia in un mondo antico
                            e <span style={{fontWeight:"bold"}}>si assaporano i veri odori della montagna</span>. Si puó subito percepire l'odore
                            peculiare del micelio.<br/>
                            Infine si arriva alla <span style={{fontWeight:"bold"}}>Cascata della Morricana</span>, il cui avvicinamento é segnato dal rumore
                            sempre piú forte delle acque.
                            Ed improvvisamente, tra le fronde dei faggi compare il salto di circa <span style={{fontWeight:"bold"}}>40 metri</span> della cascata.
                        </p>
                    </section>
                </div>
                <Slider imgArray={sliderBosco}/>
            </div>
            <div className="section-text">
                <div className="section-image-container sectionleft">
                    <section className="section">
                        <h4 className="title">Ceppo - Pizzo di Moscio</h4>
                        <hr/>
                        <div className="tag-section">
                            <span>Distanza: 7.80km</span>
                            <span>Dislivello: 1036m</span>
                            <span>Tempo di Percorrenza: 3.5h</span>
                            <span className="medium">Medio</span>
                        </div>
                        <p>
                            Escursione verso il <span style={{fontWeight:"bold"}}>Pizzo di Moscio</span>, una delle cime piú alte dei Monti della Laga (<span style={{fontWeight:"bold"}}>2411m</span>).<br/>
                            Si parte dal piazzale di Ceppo per una strada sterrata che continua in leggera salita.
                            Dopo pochi chilometri si raggiunge la radura del <span style={{fontWeight:"bold"}}>Lago dell'Orso (1800m)</span> da dove é possibile
                            ammirare tutta la catena della Laga, ed in particolare del monte <span style={{fontWeight:"bold"}}>Gorzano</span>. <br/>
                            Successivamente si imbocca un sentiero aperto che costeggia il <span style={{fontWeight:"bold"}}>Bosco della Martese</span>, e dopo 
                            alcuni chilometri in falsopiano si inizia a salire alla volta del <span style={{fontWeight:"bold"}}>Pizzo di Moscio</span>.
                            Si tratta della parte piú difficile del percorso che risale ripidamente la cresta Sud-Est della montagna fino alla vetta.<br/>
                            Una volta arrivati si puó godere dell'incredibile panorama.
                        </p>
                    </section>
                    <div className="img-container">
                        <img src={map1} alt="mappa Morricana" className="section-image"/>
                    </div>
                </div>
                <Slider imgArray={sliderPizzo}/>
            </div>
        </div>
    )
}

export default RoutesScreen
